import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseX = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.920 4.594 C 4.701 4.712,4.552 4.926,4.530 5.154 C 4.491 5.559,4.353 5.403,7.774 8.830 L 10.938 12.000 7.774 15.170 C 4.356 18.594,4.491 18.441,4.529 18.843 C 4.575 19.318,5.092 19.609,5.551 19.418 C 5.655 19.375,6.648 18.409,8.850 16.209 L 12.000 13.061 15.150 16.209 C 17.352 18.409,18.345 19.375,18.449 19.418 C 18.823 19.574,19.222 19.429,19.404 19.072 C 19.496 18.892,19.501 18.649,19.418 18.449 C 19.375 18.345,18.409 17.352,16.209 15.150 L 13.061 12.000 16.209 8.850 C 18.409 6.648,19.375 5.655,19.418 5.551 C 19.609 5.092,19.318 4.575,18.843 4.529 C 18.441 4.491,18.594 4.356,15.170 7.774 L 12.000 10.939 8.850 7.791 C 6.648 5.591,5.655 4.625,5.551 4.582 C 5.351 4.499,5.089 4.504,4.920 4.594 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgCloseX;
